var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpuestos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20.6852V3.88516C3 3.72603 3.06321 3.57341 3.17574 3.46089C3.28826 3.34837 3.44087 3.28516 3.6 3.28516H20.4C20.5591 3.28516 20.7117 3.34837 20.8243 3.46089C20.9368 3.57341 21 3.72603 21 3.88516V20.6852C21 20.8443 20.9368 20.9969 20.8243 21.1094C20.7117 21.2219 20.5591 21.2852 20.4 21.2852H3.6C3.44087 21.2852 3.28826 21.2219 3.17574 21.1094C3.06321 20.9969 3 20.8443 3 20.6852Z",
    stroke: "#01295F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.78516C14.315 8.10016 13.109 7.62416 12 7.59416M12 7.59416C10.68 7.55816 9.5 8.15516 9.5 9.78516C9.5 12.7852 15 11.2852 15 14.2852C15 15.9962 13.536 16.7312 12 16.6762M12 7.59416V5.78516M9 15.2852C9.644 16.1452 10.843 16.6352 12 16.6762M12 16.6762V18.7852",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpuestos);
export default __webpack_public_path__ + "static/media/impuestos.8564f7da648fe18ab39bde217f883ab0.svg";
export { ForwardRef as ReactComponent };